<template>
    
    <v-list-group >
        <v-list-tile 
            v-bind:to="item.link"
            slot="activator" 
            v-on:click="">
            <v-list-tile-action>
                <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
            
        </v-list-tile>
        <v-list v-if="hasSub">
            <v-list-tile  

                v-for="(sub,index) in item.sub"                             
                v-bind:key="index" 
                v-bind:to="sub.link">
                <v-list-tile-content >
                    <v-list-tile-title>{{ sub.title }}</v-list-tile-title>
                </v-list-tile-content>

            </v-list-tile>
        </v-list>
    </v-list-group>
            
   
</template>
<script>


import MainNavMenuItem from './MainNavMenuItem.vue';
export default {   
    props:[
        'item'
    ],   
    data() {
        return {            
          
        };
    },
    computed: {
        
        
    },
    methods: {
        
        hasSub: function(){            
            return this.item.sub.length
        },
        
    }
    
}
</script>